module.exports = __webpack_public_path__ + "static/media/mid1.efe17007.webm";